import React, {Component} from 'react';
import {LevelTrackerComponent} from "../StudentsComponent/Common";

class InlineProgressBox extends Component {

    constructor(props) {
        super(props);
    }

    render() {

        let animalMap = [];
        let maxlevel = this.props.maxLevel || 12;
        for (let i = 1; i <= maxlevel; i++) {
            animalMap.push(<div key={i} style={{display: "inline-block"}}>
                <img
                    className={"img-responsive"}
                    src={require(`../assets/images/animals/animal${i}.png`)}
                    title={`Level ${i}`}
                    alt={`Level ${i}`}
                    style={{opacity: this.props.level >= i ? 1 : 0.2, height:40 }}
                />
            </div>)
        }

        return (
            <div className={"container"} style={{width: "100%"}}>
                <div className="row">
                    <div className="col-md-12">
                        {animalMap}
                        {this.props.badgeNo>0?
                        <div key={this.props.maxLevel+1} style={{display: "inline-block"}}>
                            <img
                                className={"img-responsive"}
                                src={require('../assets/images/badge_'+this.props.badgeNo+'.png')}
                                title={`Level ${this.props.maxLevel+1}`}
                                alt={`Level ${this.props.maxLevel+1}`}
                                style={{opacity: this.props.level > this.props.maxLevel ? 1 : 0.2, height:40 }}
                            />
                        </div>:null
                        }
                    </div>
                </div>
                {!this.props.noDescription ?
                    <div className="row">
                        <p>I need to score <b>{this.props.steps - this.props.step}</b> correct.<br/>
                            Don't skip! Scoring stops if you skip 3 questions.</p>
                    </div>
                    : null
                }
            </div>
        );
    }
}

export default InlineProgressBox;
